import { api } from '../../../shared/services/api/client';

import { createLogger } from '../../../shared/config/logger';
const log = createLogger('rewards_settings');

export async function fetchRewardSettings() {
    log.info('Get Rewards Settings');
    return api.get('/settings/reward-system');
}

export async function updateRewardSettings(payload) {
    log.info('Update Rewards Settings');
    return api.patch('/settings/reward-system', payload);
}
